<template>
  <div class="jo-carousel" v-bind:style="{height: contentHeight + 'px'}" v-if="carousel.length>0">
    <div class="carousel-pre-box">
      <div class="carousel-pre" :style="{'border-color' : ARTICLE.theme}" @click="preFig()"></div>
    </div>
    <div class="carousel-content">
      <div class="carousel-index">
        {{ARTICLE.defaultlang=='zh'?'图表':'No.'}} <span :style="{'color' : ARTICLE.theme}" class="carousel-current">{{ currentIndex + 1 }}</span> / <span class="carousel-total">{{ carouselNum
        }}</span>
      </div>
      <div class="carousel-fig" :class="{'ie9-height':isIE9}" v-if="carousel[currentIndex].name==='fig'">
        <div class="carousel-fig-content">
          <img v-if="carouselData().graphics[0].big" v-lazy="carouselData().graphics[0].big" @click="showBigPic" id="jo-graphics" ref="graphic"/>
          <img v-else-if="carouselData().graphics[0].print" v-lazy="carouselData().graphics[0].print" @click="showBigPic" ref="graphic"/>
          <img v-else-if="carouselData().graphics[0].small" v-lazy="carouselData().graphics[0].small" @click="showBigPic" ref="graphic"/>
        </div>
      </div>
      <div class="carousel-table" :class="{'ie9-height':isIE9}" v-if="carousel[currentIndex].name==='table'">
        <el-scrollbar v-bind:style="{'height':wrapHeight + 'px'}" v-if="carouselData().table.head.length > 0 || carouselData().table.body.length > 0">
          <table cellspacing="0" cellpadding="0" ref="table" :style="{transform:scale}" id="table"
                 :border="setCellStyle(carousel[currentIndex].data.table.style,true)" v-bind:key="carouselData().id">
            <thead>
            <tr v-for="(item, index) in carouselData().table.head" v-bind:key="index">
              <th v-for="(item2, index2) in item" v-bind:key="index2" :rowspan="item2.rowspan" :colspan="item2.colspan"
                  :align="item2.align" :style="setCellStyle(item2.style)">
                <component :is="'jo' + item3.name" v-for="item3 in item2.data" v-bind:key="item3.index"
                           v-bind:data="item3.data"></component>
              </th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(item, index) in carouselData().table.body" v-bind:key="index"
                :class="{'outside-bottom-border': index == carouselData().table.body.length-1 && carouselData().table.foot.length < 1}">
              <td v-for="(item2, index2) in item" v-bind:key="index2" :rowspan="item2.rowspan" :colspan="item2.colspan"
                  :align="item2.align" :style="setCellStyle(item2.style)">
                {{ item2.index }}
                <component :is="'jo' + item3.name" v-for="item3 in item2.data" v-bind:key="item3.index"
                           v-bind:data="item3.data"></component>
              </td>
            </tr>
            </tbody>
            <tfoot>
            <tr v-for="(item, index) in carouselData().table.foot" v-bind:key="index"
                :class="{'outside-bottom-border': index==carouselData().table.foot.length-1}">
              <td v-for="(item2, index2) in item" v-bind:key="index2" :rowspan="item2.rowspan" :colspan="item2.colspan"
                  :align="item2.align" :style="setCellStyle(item2.style)">
                {{ item2.index }}
                <component :is="'jo' + item3.name" v-for="item3 in item2.data" v-bind:key="item3.index"
                           v-bind:data="item3.data"></component>
              </td>
            </tr>
            </tfoot>
          </table>
        </el-scrollbar>
        <img v-else-if="carouselData().hasOwnProperty('graphics') && carouselData().graphics.hasOwnProperty('big')" :src="carouselData().graphics.big"/>
        <img v-else-if="carouselData().hasOwnProperty('beforegraphics') && carouselData().beforegraphics.length>0" :src="carouselData().beforegraphics[0].big"/>
      </div>
      <div class="carousel-title" v-bind:style="{'background-color' : this.ARTICLE.theme}">
        <div class="carousel-title-content" v-if="carouselData().caption.length>0">
          <p v-for="(i,index) in getCaptions"
             :class="index == 0 ? 'carousel-title-content-ch' : 'carousel-title-content-en'" v-if="i.length>0">
            <span v-for="(captionItem,index2) in i" :key="index2" class="main-title">
                  <span v-if="index2!=0">&nbsp;&nbsp;</span>
                  <component :is="'jo' + item.name" v-for="(item,index3) in captionItem.label" v-bind:key="'QAQ'+currentIndex+index3"
                             v-bind:data="item.data"></component>
                  <component :is="'jo' + item.name" v-for="(item,index1) in captionItem.title" v-bind:key="'OVO'+index+index1+carouselData().id"
                             v-bind:data="item.data"></component></span>
            <span v-if="i[0].label && carouselData().cellunit && item1.lang == i[0].lang" v-for="item1 in carouselData().cellunit">(
              <component :is="'jo' + item.name" v-for="(item,index4) in item1.data"
                         v-bind:key="index4+'cell'" v-bind:data="item.data"></component>
              )</span><!--表格单位-->
            <!--组图分图题-->
            <span v-if="carouselData().subCaption && carouselData().subCaption.length>0 ">
              <span v-for="subCaptionItem in carouselData().subCaption"
                    v-if="subCaptionItem.lang == i[0].lang || (i[0].lang==ARTICLE.defaultlang && getCaptions[1].length<1 && carouselData().subCaption.length==1)">
                        --
                        <component :is="'jo' + item.name"
                                   v-for="(item,index) in subCaptionItem.label"
                                   v-bind:key="'QAQ'+subCaptionItem.label+index" v-bind:data="item.data"></component>
                        <component :is="'jo' + item.name"
                                   v-for="(item,index) in subCaptionItem.title"
                                   v-bind:key="'OVO'+subCaptionItem.label+index" v-bind:data="item.data"></component>
                    </span>
              </span>
            <!--组图分图题end-->
            <!--单图分图题-->
            <span v-if="carouselData().subcaption && carouselData().subcaption.length>0 ">
              <span v-for="(subItem,index) in subcaptionFilter(i[0].lang)" :key="index">
                <span v-if="index==0">--</span>
                        <component :is="'jo' + item.name"
                                   v-for="item in subItem.label"
                                   v-bind:key="'QAQ'+subItem.label+index"
                                   v-bind:data="item.data"></component>
                        <component :is="'jo' + item.name"
                                   v-for="item in subItem.title"
                                   v-bind:key="'OVO'+subItem.label+index"
                                   v-bind:data="item.data"></component>&nbsp;&nbsp;</span>
                    </span>
            <!--单图分图题end-->
          </p>
        </div>
        <!--图注表注-->
        <div v-if="carouselData().note && carouselData().note.length>0" class="carousel-note-content">
          <p v-for="(item,index) in carouselData().note" :key="'note'+index">
            <!--{{item.lang == "zh" ? '注:' : 'NOTE:'}}-->
            <span v-for="(item1,index1) in item.data"><component :is="'jo' + item1.name" v-bind:key="index1"
                       v-bind:data="item1.data" v-bind:hideVocab="true"></component>
            <span
              v-if="index1 != item.data.length-1 && !hasColon(item1)">{{item.lang == 'zh' ? '；' : '; '}}</span></span>
            <br/>
          </p>
        </div>
        <a v-if="carousel[currentIndex].name==='fig' && !isLoading && allowDownload(carouselData().graphics[0].big)" style="cursor: pointer"
           @click="download(carouselData().graphics[0].big)">
          <img class="down" src="../../assets/img/down.png"/></a>
        <a v-else-if="carousel[currentIndex].name==='table' && carouselData().id!==''" style="cursor: pointer"
           :href="setDownloadTableUrl(carouselData().id)">
          <img class="down" src="../../assets/img/down.png"/></a>
      </div>
    </div>
    <div class="carousel-next-box">
      <div class="carousel-next" @click="nextFig()" :style="{'border-color' : ARTICLE.theme}"></div>
    </div>
    <el-dialog width="inherit" top="0" custom-class="jo-bigPicDialog" :visible.sync="isShowBigPic">
      <img v-if="carousel[currentIndex].name==='fig'" :src="carouselData().graphics[0].big"
           :style="{ 'max-height': picHeight + 'px', 'max-width': picWidth + 'px' }">
      <img v-else-if="carouselData().hasOwnProperty('graphics') && carouselData().graphics.hasOwnProperty('big')" :src="carouselData().graphics.big"
           :style="{ 'max-height': picHeight + 'px', 'max-width': picWidth + 'px' }">
    </el-dialog>
  </div>
</template>

<script>
  /* eslint-disable */
  import jotext from '../maincontent/body/common/text.vue'
  import josup from '../maincontent/body/common/sup.vue'
  import josub from '../maincontent/body/common/sub.vue'
  import jobold from '../maincontent/body/common/bold.vue'
  import joitalic from '../maincontent/body/common/italic.vue'
  import jop from '../maincontent/body/common/p.vue'
  import jointablefig from '../maincontent/body/fig/intablefig.vue'
  import jofig from '../maincontent/body/fig/fig.vue'
  import joinlineformula from '../maincontent/body/formula/inlineformula.vue'
  import joinlinegraphic from '../maincontent/body/fig/inlinegraphic.vue'
  import joxref from '../maincontent/body/common/xref.vue'

  export default {
    components: {
      jotext,
      josup,
      josub,
      joitalic,
      jobold,
      jop,
      jointablefig,
      joinlineformula,
      joinlinegraphic,
      joxref
    },
    data() {
      return {
        lang: this.ARTICLE.defaultlang,
        height: 0,
        carousel: [],
        body: [],
        currentIndex: 0,
        picHeight: 'inherit',
        picWidth: 'inherit',
        isShowBigPic: false,
        clientHeight: 0,
        tableHeight: '60%',
        tableWidth: 0,
        wrapWidth: 0,
        scaleValue: 1,
        isLoading: true,
        imgWidth: 'auto'
      }
    },
    computed: {
      carouselNum() {
        return this.carousel.length
      },
      contentHeight() {
        return this.clientHeight - this.height;
      },
      scale: function () {
        if (this.wrapWidth < this.tableWidth && this.wrapWidth>1) {
          this.scaleValue = this.wrapWidth / this.tableWidth;
//          部署时出现 scaleValue=0 的情况导致表格不显示
          if (this.scaleValue <= 0) this.scaleValue = 1;
          return 'scale(' + this.scaleValue + ')';
        } else this.scaleValue = 1;
      },
      wrapHeight: function () {
        return this.tableHeight * this.scaleValue
      },
      getCaptions() {
        let captions = [[], []];
        for (let i = 0; i < this.carousel[this.currentIndex].data.caption.length; i++) {
          let item = this.carousel[this.currentIndex].data.caption[i];
          if (i === 0) {
            captions[0].push(item)
          } else {
            captions[1].push(item)
          }
        }
        return captions;
      },
      isIE9(){
        return navigator.userAgent.indexOf('MSIE 9.0')>0
      }
    },
    methods: {
      carouselData() {
        return this.carousel[this.currentIndex].data
      },
      subcaptionFilter(language) {
        return this.carousel[this.currentIndex].data.subcaption.filter((item) => {
          return item.lang === language;
        })
      },
      preFig() {
        if (this.currentIndex == 0) {
          this.currentIndex = this.carousel.length - 1
        } else {
          this.currentIndex--
        }
        if (this.carousel[this.currentIndex].name === 'fig') {
          this.isLoading = true;
        }

      },
      nextFig() {
        if (this.currentIndex == this.carousel.length - 1) {
          this.currentIndex = 0
        } else {
          this.currentIndex++;
        }
        if (this.carousel[this.currentIndex].name === 'fig') {
          this.isLoading = true;
        }

      },
      findFigTableInSec(sec) {
        for (var i in sec.data) {
          if (sec.data[i].name == 'sec') {
            this.findFigTableInSec(sec.data[i])
          }
          if (sec.data[i].name == 'figgroup') {
            let caption = sec.data[i].data.caption
            let note = sec.data[i].data.note
            for (var j in sec.data[i].data.grid) {
              for (var k in sec.data[i].data.grid[j]) {
                var fig = sec.data[i].data.grid[j][k]
                fig.data.subCaption = sec.data[i].data.grid[j][k].data.caption;
                fig.data.caption = caption;
                fig.data.note = note;
                this.carousel.push(fig)
              }
            }
          }
          if (sec.data[i].name == 'fig' && sec.data[i].data.graphics.length > 1) {
            for (var j in sec.data[i].data.graphics) {
              let fig = {
                name: '',
                data: {
                  caption: [],
                  subcaption: [],
                  note: [],
                  graphics: []
                }
              };
              fig.name = 'fig';
              fig.data.caption = sec.data[i].data.caption;
              fig.data.subcaption = sec.data[i].data.subcaption;
              fig.data.note = sec.data[i].data.note;
              fig.data.graphics.push(sec.data[i].data.graphics[j]);
              this.carousel.push(fig)
            }
          }
          if (sec.data[i].name == 'table') {
            for (var j in sec.data[i].data.table) {
              let tableData = {
                name: '',
                data: {
                  id:'',
                  caption: [],
                  subcaption: [],
                  note: [],
                  table:{},
                  cellunit:[]
                }
              };
              tableData.name = 'table';
              tableData.data.id = sec.data[i].data.id;
              tableData.data.caption = sec.data[i].data.caption;
              tableData.data.subcaption = sec.data[i].data.subcaption;
              tableData.data.note = sec.data[i].data.note;
              tableData.data.cellunit = sec.data[i].data.cellunit;
              tableData.data.table = sec.data[i].data.table[j];
              this.carousel.push(tableData)
            }
          }
          if (sec.data[i].name == 'fig' && sec.data[i].data.graphics.length === 1) {
            this.carousel.push(sec.data[i])
          }
        }
      },
      findFigTable(body){
        for (var i in body) {
          if (body[i].name == 'sec') {
            this.findFigTableInSec(body[i])
          }
          if (body[i].name == 'fig' && body[i].data.graphics.length === 1) {
            this.carousel.push(body[i])
          }
          if (body[i].name == 'fig' && body[i].data.graphics.length > 1) {
            for (var j in body[i].data.graphics) {
              let fig = {
                name: '',
                data: {
                  caption: [],
                  subcaption: [],
                  note: [],
                  graphics: []
                }
              };
              fig.name = 'fig';
              fig.data.caption = body[i].data.caption;
              fig.data.subcaption = body[i].data.subcaption;
              fig.data.note = body[i].data.note;
              fig.data.graphics[0] = body[i].data.graphics[j];
              this.carousel.push(fig)
            }
          }
          if ( body[i].name == 'table' && body[i].data.caption.length > 0){
            for (var j in body[i].data.table) {
              let tableData = {
                name: '',
                data: {
                  id:'',
                  caption: [],
                  subcaption: [],
                  note: [],
                  table: {},
                  cellunit :[]
                }
              };
              tableData.name = 'table';
              tableData.data.id = body[i].data.id;
              tableData.data.caption = body[i].data.caption;
              tableData.data.subcaption = body[i].data.subcaption;
              tableData.data.note = body[i].data.note;
              tableData.data.cellunit = body[i].data.cellunit;
              tableData.data.table = body[i].data.table[j];
              this.carousel.push(tableData)
            }
          }
          if (body[i].name == 'figgroup') {
            let caption = body[i].data.caption
            let note = body[i].data.note
            for (var j in body[i].data.grid) {
              for (var k in body[i].data.grid[j]) {
                var fig = body[i].data.grid[j][k]
                fig.data.subCaption = body[i].data.grid[j][k].data.caption;
                fig.data.caption = caption;
                fig.data.note = note;
                this.carousel.push(fig)
              }
            }
          }
        }
      },
      objDeepCopy(source) {
        var sourceCopy = source instanceof Array ? [] : {};
        for (var item in source) {
          sourceCopy[item] = typeof source[item] === 'object' ? this.objDeepCopy(source[item]) : source[item];
        }
        return sourceCopy;
      },
      showBigPic() {
        this.isShowBigPic = true;
        this.picHeight = document.documentElement.clientHeight * 0.8;
        this.picWidth = document.documentElement.clientWidth * 0.9;

        if (navigator.userAgent.indexOf('MSIE 9.0')>0) {
          let img = new Image();
          img.src = this.carousel[this.currentIndex].data.graphics[0].big;
          let imgWidth = img.width;
          let imgHeight = img.height;
          if (img.height > this.picHeight){
            this.picWidth = this.picHeight*img.width/img.height;
            imgHeight = this.picHeight;
            imgWidth = this.picWidth;
          }else if (img.width>this.picWidth){
            imgWidth = this.picWidth;
          }
          $('.jo-bigPicDialog img').css({width:imgWidth, height:imgHeight});
          $('.jo-bigPicDialog').css({width:imgWidth+40, margin:'auto', 'margin-top':(document.documentElement.clientHeight-imgHeight-80)/2});
        }
      },
      download(url) {
        const userAgent = navigator.userAgent;
        if (userAgent.indexOf('MSIE') > -1 || userAgent.indexOf('rv:11.0') > -1) {
          let iframe = document.createElement("iframe");
          iframe.src = url;
          iframe.id = 'IframeReportImg';
          iframe.style.display = 'none'
          if (iframe.attachEvent){
            iframe.attachEvent("onload", downloadImg);
          } else {
            iframe.onload = downloadImg;
          }
          document.body.appendChild(iframe);
          function downloadImg () {
            window.frames["IframeReportImg"].document.execCommand("SaveAs");
            document.body.removeChild(document.getElementById('IframeReportImg'));
          }

        } else {
          let image = new Image();
          let canvas = document.createElement('canvas');
          image.setAttribute('crossOrigin', 'anonymous')
          image.onload = function () {
            canvas.width = image.width;
            canvas.height = image.height;
            let context = canvas.getContext('2d');
            context.drawImage(image, 0, 0, image.width, image.height);
            canvas.getContext('2d').drawImage(image, 0, 0, image.width, image.height);
            canvas.toBlob((blob)=>{
              let a = document.createElement('a');
              let event = new MouseEvent('click');
              a.href = window.URL.createObjectURL(blob);
              a.download = '';
              a.dispatchEvent(event);
              a.remove();
            }, "image/jpeg");
          }

          image.src = url

        }
      },
      setDownloadTableUrl(tableId){
        if (this.ARTICLE.offline && this.ARTICLE.offline == true){
          let title = $('.carousel-title-content-ch .main-title').text().replace(/\s/g,"");
          return './table/' + title + '.xls'
        }
        return  window.location.pathname + 'downloadTable?tableId='+tableId + '&type=xls';
      },
      hasColon(item){
        let hasColon = false;
        if (item.name === 'p'){
          hasColon = this.hasColon(item.data[item.data.length-1]);
        } else if (item.name==='text'){
          if(item.data.lastIndexOf(';')===item.data.length-1 ||
            item.data.lastIndexOf('；')===item.data.length-1){
            return true
          }
        }
        return hasColon;
      },
      setCellStyle(style,isOut) {
        let border;
        let borderWidth = 1;
        if (isOut){
          borderWidth = 2;
        }
        let borderDoubleWidth = 3;
        if (style && style!==''){
          border = style.replace('border-right', 'border-right-style').replace('border-top', 'border-top-style')
              .replace('border-bottom', 'border-bottom-style').replace('border-left', 'border-left-style') + ';border-width:'+borderWidth+'px;border-color: #333;';
          if (style.search(/border-top:Double/i)>=0){
            border += ';border-top-width:'+borderDoubleWidth+'px;';
          }
          if (style.search(/border-right:Double/i)>=0){
            border += ';border-right-width:'+borderDoubleWidth+'px;';
          }
          if (style.search(/border-bottom:Double/i)>=0){
            border += ';border-bottom-width:'+borderDoubleWidth+'px;';
          }
          if (style.search(/border-left:Double/i)>=0){
            border += ';border-left-width:'+borderDoubleWidth+'px;';
          }
        }
        return border;
      },
      allowDownload(url){
        return window.location.origin !== 'file://' && url.indexOf('http') < 0;
      }
    },
    created() {
      this.body = this.objDeepCopy(this.ARTICLE.body)
      //从json中的body节点找到所有图和表，放入this.carousel中
      this.findFigTable(this.body);
      let appendix = this.objDeepCopy(this.ARTICLE.appendix);
      this.findFigTable(appendix);

    },
    mounted() {
      this.height = this.GLOBAL.topbarheight;
      this.clientHeight = $(window).height();
      $(window).resize(() => {
        this.clientHeight = $(window).height();
        if ($(this.$refs.table).is(':visible')) {
          this.wrapWidth = Math.floor($('.carousel-table').width() * 0.8);
          this.tableWidth = $(this.$refs.table).width();
        }
      });

      if (navigator.userAgent.indexOf('MSIE 9.0')>0){
        $('.carousel-content').css('height','100%')
      }
    },
    updated() {
//      this.GLOBAL.enchanceNoBreak();
      let _this = this;
      function setTable () {
        _this.tableHeight = $(_this.$refs.table).height() + 20;
        _this.tableWidth = $(_this.$refs.table).width();
      }
      if (this.carousel[this.currentIndex].name === 'table' && $(this.$refs.table).is(':visible')) {
        if($(this.$refs.table).find('.jo-formula').length>0){
          MathJax.Hub.Queue(["Typeset", MathJax.Hub,_this.$refs.table],[setTable])
        } else setTable();
        this.wrapWidth = Math.floor($('.carousel-table').width() * 0.8);
        /*if (navigator.userAgent.indexOf('Firefox')>-1){
         $(_this.$refs.table).css('border-collapse','unset')
         }*/
      }
      if (this.carousel[this.currentIndex].name === 'fig') {
        let img = new Image();
        img.src = this.carousel[this.currentIndex].data.graphics[0].big;
        let wrapperHeight = $('.carousel-fig').height();
        let _this = this;
        img.onload = function () {
          _this.isLoading = false;
          if (navigator.userAgent.indexOf('MSIE 9.0')>0) {
            if(img.height > wrapperHeight){
              $(_this.$refs.graphic).width(wrapperHeight*img.width/img.height);
            }else $(_this.$refs.graphic).width(img.width);
          }
        }
      }

      if (navigator.userAgent.indexOf('MSIE 9.0')>0){
        let contentHeight = document.body.offsetHeight - this.height -120 - $('#page-foot').height();
        let titleHeight = $('.carousel-title').height();
        $('.carousel-fig').css('height',contentHeight - titleHeight);
        $('.carousel-table').css('height',contentHeight - titleHeight);
      }
    }
  }
</script>

<style lang="scss">
  .jo-carousel {
    z-index: -1 !important;
    min-height: 518px;
    background: #e8f0f0;
    display: flex;
    .carousel-pre-box {
      display: inline-block;
      position: relative;
      width: 114px;
      flex-shrink: 0;
      float: left \9
    ;
      height: 100% \9
    ;
      .carousel-pre {
        border-top: solid 8px #00A2AF;
        border-left: solid 8px #00A2AF;
        border-radius: 8px;
        position: absolute;
        left: 53px;
        top: 40%;
        height: 35px;
        width: 35px;
        transform: rotate(-45deg);
        cursor: pointer;
        opacity: 0.8;
      }
      .carousel-pre:hover {
        opacity: 1.0;
      }
    }
    .carousel-next-box {
      display: inline-block;
      position: relative;
      width: 114px;
      flex-shrink: 0;
      float: left \9;
      height: 100% \9;
      .carousel-next {
        border-top: solid 8px #00A2AF;
        border-right: solid 8px #00A2AF;
        border-radius: 8px;
        position: absolute;
        right: 53px;
        top: 40%;
        height: 35px;
        width: 35px;
        transform: rotate(45deg);
        cursor: pointer;
        opacity: 0.8;
      }
      .carousel-next:hover {
        opacity: 1.0;
      }
    }
    .carousel-content {
      background: #fff;
      flex-grow: 1;
      display: flex;
      flex-direction: column;
      float: left \9;
      width: calc(100% - 234px);
      /*height: 100%;*/
      .carousel-index {
        height: 80px;
        margin: 0 auto 10px;
        line-height: 80px;
        font-size: 30px;
        color: #333;
        text-align: center;
        background: #fff;
        flex: 0 0 auto;
        .carousel-current {
          color: #009999;
          font-weight: bold;
        }
      }
      .carousel-fig {
        flex-grow: 1;
        height: 0;
        width: 100%;
        .carousel-fig-content {
          width: 100%;
          height: 100%;
          text-align: center;
          position: relative;
          img {
            position: absolute;
            top: 0;
            bottom: 0;
            left: 0;
            right: 0;
            margin: auto;
            max-width: 90%;
            max-height: 100%;
          }

        }
      }
      .carousel-table {
        /*height: 100%;*/
        height: 0;
        flex-grow: 1;
        display: flex;
        justify-content: center;
        align-items: center;
        text-align: center \9
      ;
        img{
          margin: auto;
          max-width: 90%;
          max-height: 100%;
        }
        .el-scrollbar {
          width: 80%;
          /*margin: 0 auto ;*/
          max-height: 100%;
          overflow-x: hidden;
          overflow-y: auto;
          table {
            border-collapse: collapse;
            border-left: none;
            border-right: none;
            border-top: 2px solid #333;
            border-bottom: 2px solid #333;
            width: 100%;
            transform-origin: 0 0;
            -ms-transform-origin: 0 0;
            thead {
              th {
                border:none;
                height: 30px;
                font-size: 14px;
                color: #333;
                padding: 0 5px;
                max-width: 400px;
                word-break: break-all;
              }
            }
            tbody {
              td {
                border: none;
                height: 30px;
                line-height: 30px;
                font-size: 14px;
                color: #333;
                min-width: 70px;
                padding: 3px 5px;
                max-width: 400px;
                word-break: break-all;
              }
            }
            tfoot {
              td {
                border: none;
                /*border-top: 0.6px solid #000;*/
                font-size: 1.4rem;
                color: #333;
                padding: 5px;
                max-width: 400px;
                word-break: break-all;
              }
            }
            img{
              max-height: unset !important;
            }
            p {
              font-size: 14px;
              color: #333;
              min-height: 24px;
            }
          }
        }
      }
      .ie9-height{
        min-height: 50%;
        position: relative;
        .el-scrollbar{
          margin: auto;
          position: absolute;
          top:0;
          bottom: 0;
          left: 0;
          right: 0;
        }
      }
      .carousel-title {
        position: relative;
        min-height: 85px;
        /*max-height: 180px;*/
        margin-top: 20px;
        text-align: center;
        background-color: #0ea7b3;
        flex: 0 0 auto;
        max-height: 120px;
        overflow-y: auto;
        .carousel-title-content {
          /*width:1045px;*/
          /*width: 75%;*/
          padding: 7px 60px 0 60px;
          margin: auto;
          .carousel-title-content-ch {
            margin-top: 5px;
            line-height: 24px;
            color: #fff;
            text-align: center;
            font-weight: bold;
            font-family: 'Arial', 'Microsoft YaHei', '微软雅黑', 'Helvetica', 'sans-serif';
            font-size: 16px !important;
          }
          .carousel-title-content-en {
            margin-top: 5px;
            color: #fff;
            font-size: 1.6rem;
            font-weight: bold;
            line-height: 24px;
          }
        }
        .down {
          position: absolute;
          right: 15px;
          top: 10px;
          width: 30px;
          height: 30px;
        }
        .carousel-note-content {
          padding: 0 60px;
          p {
            display: inline;
            color: #fff;
            font-size: 1.4rem;
            a,.jo-refer-sup{
              color: #b9c9b3 !important;
            }
            .jo-vocab {
              color: #fff !important;
            }
          }
        }
      }
    }
    img {
      -moz-user-select: none;
      -webkit-user-select: none;
      -ms-user-select: none;
      user-select: none;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/carousel/Carousel.vue